import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import AllNoneMember from './AllNoneMember'

class ParselAllNoneMember extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={AllNoneMember} {...props}/>
   )
 }
}



export default ParselAllNoneMember;
